import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { assets } from '../constants/theme';

const CLOVER_STORE_URL = 'https://www.clover.com/online-ordering/savana-sips';

const handleCloverCheckout = (productName) => {
  const url = `${CLOVER_STORE_URL}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

const products = [
  // Single Origins
  {
    category: 'Single Origins',
    items: [
      {
        id: 'kenyan-aa-250',
        badge: 'Premium Flagship',
        badgeClass: 'badge-dark',
        name: 'Kenyan AA',
        subtitle: 'Rare Single Origin',
        origin: 'Mt. Kenya Slopes, Kenya',
        weight: '250g / 8.8oz',
        roast: 'Light – Medium',
        score: '84–88 SCA',
        price: '$18.99',
        oldPrice: '$22.99',
        tag: 'Best Seller',
        rating: 5,
        reviews: 142,
        img: assets.imgBrew,
        notes: ['Blackcurrant', 'Blueberry', 'Jasmine', 'Citrus Zest'],
        desc: 'The crown jewel of African specialty coffee. Kenya AA delivers an unrivaled wine-like body, bright acidity, and a complex blackcurrant-forward profile that transforms your morning.',
        available: true,
        seasonal: true,
      },
      {
        id: 'arabica-a-250',
        badge: 'Specialty Grade',
        badgeClass: 'badge-gold',
        name: 'Arabica A Grade',
        subtitle: 'Kenya Highland Origin',
        origin: 'Kenyan Highlands',
        weight: '250g / 8.8oz',
        roast: 'Medium',
        score: '82+ SCA',
        price: '$15.99',
        oldPrice: null,
        tag: '',
        rating: 5,
        reviews: 98,
        img: assets.featureLeft,
        notes: ['Chocolate', 'Caramel', 'Roasted Nuts', 'Citrus'],
        desc: 'Our signature Arabica A Grade — complex, nuanced, and perfectly balanced. Larger beans, exceptional consistency, elevated daily specialty.',
        available: true,
        seasonal: false,
      },
      {
        id: 'arabica-b-500',
        badge: 'Daily Specialty',
        badgeClass: 'badge-cream',
        name: 'Arabica B Grade',
        subtitle: 'Kenyan Blend',
        origin: 'Kenyan Highlands & West Africa',
        weight: '500g / 17.6oz',
        roast: 'Medium – Dark',
        score: '80+ SCA',
        price: '$22.99',
        oldPrice: null,
        tag: 'Best Value',
        rating: 4,
        reviews: 215,
        img: assets.featureRight,
        notes: ['Dark Chocolate', 'Brown Sugar', 'Spice', 'Earthy'],
        desc: 'Your reliable everyday specialty companion. Approachable, full-bodied, and consistent — quality coffee for every morning without compromise.',
        available: true,
        seasonal: false,
      },
    ],
  },
  // Blends
  {
    category: 'Signature Blends',
    items: [
      {
        id: 'savana-sunrise-blend',
        badge: 'Signature Blend',
        badgeClass: 'badge-gold',
        name: 'Savana Sunrise Blend',
        subtitle: 'Morning Ritual Blend',
        origin: 'Kenya + Ethiopia',
        weight: '250g / 8.8oz',
        roast: 'Medium',
        score: '83 SCA',
        price: '$16.99',
        oldPrice: null,
        tag: 'New Arrival',
        rating: 5,
        reviews: 67,
        img: assets.imgBrew,
        notes: ['Peach', 'Honey', 'Caramel', 'Mild Acidity'],
        desc: 'Crafted to be the perfect sunrise companion. Our Sunrise Blend balances Kenyan brightness with Ethiopian floral notes for a gentle, welcoming morning cup.',
        available: true,
        seasonal: false,
      },
      {
        id: 'community-roast',
        badge: 'Impact Blend',
        badgeClass: 'badge-green',
        name: 'Community Roast',
        subtitle: 'Direct Impact Blend',
        origin: 'Multi-Origin Kenya',
        weight: '250g / 8.8oz',
        roast: 'Medium – Dark',
        score: '81 SCA',
        price: '$14.99',
        oldPrice: null,
        tag: '100% Impact',
        rating: 5,
        reviews: 183,
        img: assets.imgFarm,
        notes: ['Chocolate', 'Brown Sugar', 'Stone Fruit', 'Walnuts'],
        desc: '100% of proceeds from Community Roast fund our farmer empowerment programs. Excellent coffee that creates real, measurable change on the ground.',
        available: true,
        seasonal: false,
      },
    ],
  },
  // Equipment
  {
    category: 'Brewing Equipment',
    items: [
      {
        id: 'savana-tumbler',
        badge: 'Merchandise',
        badgeClass: 'badge-dark',
        name: 'Savana Sips Tumbler',
        subtitle: '16oz Insulated',
        origin: 'Designed in Kenya',
        weight: '16oz',
        roast: '—',
        score: '—',
        price: '$29.99',
        oldPrice: '$34.99',
        tag: 'Limited',
        rating: 5,
        reviews: 44,
        img: assets.beansCloseup,
        notes: ['Insulated 6 hrs', 'BPA Free', 'Dishwasher Safe'],
        desc: 'Our signature Savana Sips tumbler. Keeps your coffee perfectly hot for 6 hours, cold for 12. Beautifully branded, built for your ritual.',
        available: true,
        seasonal: false,
      },
    ],
  },
];

function StarRating({ rating }) {
  return (
    <span className="stars">
      {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
    </span>
  );
}

function ProductCard({ product }) {
  const s = {
    card: {
      backgroundColor: '#fff',
      border: '1px solid #EDE5DC',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    },
    imgWrap: { position: 'relative', aspectRatio: '1/1', overflow: 'hidden' },
    img: { width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' },
    imgOverlay: {
      position: 'absolute', inset: 0,
      background: 'linear-gradient(to top, rgba(28,18,9,0.3) 0%, transparent 50%)',
    },
    badges: { position: 'absolute', top: '1rem', left: '1rem', display: 'flex', gap: '0.4rem', flexWrap: 'wrap' },
    tag: {
      position: 'absolute', top: '1rem', right: '1rem',
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.1em',
      textTransform: 'uppercase', color: '#fff',
      backgroundColor: '#A63C1E', padding: '0.2rem 0.6rem',
      borderRadius: '2px',
    },
    body: { padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.6rem', flex: 1 },
    origin: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.1em',
      textTransform: 'uppercase', color: '#A0693A',
    },
    name: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '1.5rem', color: '#1C1209', lineHeight: 1.1,
    },
    subtitle: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.8rem', color: '#8B5E3C',
    },
    ratingRow: { display: 'flex', alignItems: 'center', gap: '0.5rem' },
    reviewCount: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.75rem', color: '#8B5E3C',
    },
    desc: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.85rem', color: '#4A2C1A', lineHeight: 1.65,
      flex: 1,
    },
    notesRow: { display: 'flex', flexWrap: 'wrap', gap: '0.3rem' },
    meta: {
      display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
      gap: '0.4rem', borderTop: '1px solid #EDE5DC', paddingTop: '0.75rem',
    },
    metaItem: { display: 'flex', flexDirection: 'column', gap: '0.15rem' },
    metaLabel: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.6rem', fontWeight: 700, letterSpacing: '0.1em',
      textTransform: 'uppercase', color: '#B08060',
    },
    metaVal: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.8rem', fontWeight: 600, color: '#1C1209',
    },
    priceRow: { display: 'flex', alignItems: 'center', gap: '0.75rem' },
    price: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '1.8rem', color: '#A63C1E', fontWeight: 600,
    },
    oldPrice: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.95rem', color: '#B08060',
      textDecoration: 'line-through',
    },
    seasonal: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.72rem', color: '#2D6A2E',
      fontWeight: 600, letterSpacing: '0.05em',
    },
    ctaSection: { padding: '0 1.5rem 1.5rem', marginTop: 'auto' },
  };

  return (
    <div style={s.card}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.1)';
        const img = e.currentTarget.querySelector('img');
        if (img) img.style.transform = 'scale(1.04)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
        const img = e.currentTarget.querySelector('img');
        if (img) img.style.transform = 'scale(1)';
      }}
    >
      <div style={s.imgWrap}>
        <img src={product.img} alt={product.name} style={s.img} loading="lazy" />
        <div style={s.imgOverlay} />
        <div style={s.badges}>
          <span className={`badge ${product.badgeClass}`}>{product.badge}</span>
        </div>
        {product.tag && <div style={s.tag}>{product.tag}</div>}
      </div>
      <div style={s.body}>
        <div style={s.origin}>{product.origin}</div>
        <div>
          <h3 style={s.name}>{product.name}</h3>
          <div style={s.subtitle}>{product.subtitle}</div>
        </div>
        <div style={s.ratingRow}>
          <StarRating rating={product.rating} />
          <span style={s.reviewCount}>({product.reviews} reviews)</span>
        </div>
        <p style={s.desc}>{product.desc}</p>
        <div style={s.notesRow}>
          {product.notes.slice(0, 3).map(n => <span key={n} className="tasting-tag">{n}</span>)}
        </div>
        <div style={s.meta}>
          <div style={s.metaItem}>
            <span style={s.metaLabel}>Weight</span>
            <span style={s.metaVal}>{product.weight}</span>
          </div>
          <div style={s.metaItem}>
            <span style={s.metaLabel}>Roast</span>
            <span style={s.metaVal}>{product.roast}</span>
          </div>
          <div style={s.metaItem}>
            <span style={s.metaLabel}>Score</span>
            <span style={s.metaVal}>{product.score}</span>
          </div>
        </div>
        <div style={s.priceRow}>
          <span style={s.price}>{product.price}</span>
          {product.oldPrice && <span style={s.oldPrice}>{product.oldPrice}</span>}
          {product.seasonal && <span style={s.seasonal}>🌿 Seasonal</span>}
        </div>
      </div>
      <div style={s.ctaSection}>
        <button
          className="btn-clover"
          id={`buy-${product.id}`}
          onClick={() => handleCloverCheckout(product.name)}
          aria-label={`Buy ${product.name} on Clover`}
        >
          🛒 Buy Now on Clover
        </button>
      </div>
    </div>
  );
}

export default function ProductsPage() {
  useEffect(() => {
    document.title = 'Shop | Specialty Coffee Products | Savana Sips';
    window.scrollTo(0, 0);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('fadeIn');
      });
    }, { threshold: 0.04 });

    document.querySelectorAll('.prd-fade').forEach((el, i) => {
      el.style.transitionDelay = `${i * 0.07}s`;
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const s = {
    page: { backgroundColor: '#FAF7F2', paddingTop: '100px' },
    pageHero: {
      position: 'relative', padding: '6rem 6% 5rem',
      backgroundColor: '#1C1007', overflow: 'hidden', textAlign: 'center',
    },
    heroBg: {
      position: 'absolute', inset: 0,
      backgroundImage: `url('${assets.imgProducts}')`,
      backgroundSize: 'cover', backgroundPosition: 'center 30%',
      opacity: 0.2,
    },
    heroContent: { position: 'relative', zIndex: 1 },
    breadcrumb: {
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '0.5rem', marginBottom: '1.5rem',
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.75rem', color: 'rgba(250,247,242,0.5)',
    },
    pageTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 'clamp(2.8rem, 6vw, 5rem)',
      color: '#FAF7F2', lineHeight: 1.08, marginBottom: '1.25rem',
    },
    accentText: { fontStyle: 'italic', color: '#D96D29' },
    pageSubtitle: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '1.05rem', color: 'rgba(250,247,242,0.7)',
      lineHeight: 1.7, maxWidth: '560px', margin: '0 auto 2rem',
    },
    cloverNote: {
      display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
      backgroundColor: 'rgba(45,106,46,0.2)',
      border: '1px solid rgba(45,106,46,0.4)',
      borderRadius: '3px', padding: '0.6rem 1.25rem',
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.8rem', color: '#8BC98C',
    },
    main: { maxWidth: '1240px', margin: '0 auto', padding: '5rem 6%' },
    categorySection: { marginBottom: '5rem' },
    categoryLabel: {
      display: 'flex', alignItems: 'center', gap: '1.5rem',
      marginBottom: '2.5rem',
    },
    categoryTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '2rem', color: '#1C1209', whiteSpace: 'nowrap',
    },
    categoryLine: { flex: 1, height: '1px', backgroundColor: '#EDE5DC' },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '2rem',
    },
    wholesaleBanner: {
      backgroundColor: '#1C1007',
      padding: '4rem 3rem', textAlign: 'center',
      marginTop: '3rem',
    },
    bannerTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '2.2rem', color: '#FAF7F2', marginBottom: '1rem',
    },
    bannerText: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.95rem', color: 'rgba(250,247,242,0.7)',
      lineHeight: 1.7, maxWidth: '500px', margin: '0 auto 2rem',
    },
    ctaRow: { display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' },
  };

  return (
    <div style={s.page} className="page-enter">
      <div style={s.pageHero}>
        <div style={s.heroBg} aria-hidden="true" />
        <div style={s.heroContent}>
          <div style={s.breadcrumb}>
            <Link to="/" style={{ color: 'rgba(250,247,242,0.45)', textDecoration: 'none' }}>Home</Link>
            <span>›</span>
            <span>Products</span>
          </div>
          <h1 style={s.pageTitle}>
            Find Your <span style={s.accentText}>Perfect Blend</span>
          </h1>
          <p style={s.pageSubtitle}>
            Every purchase supports African farmers and builds community opportunities.
            Specialty-grade coffee, directly sourced, delivered to you.
          </p>
          <div style={s.cloverNote}>
            🛒 Secure checkout powered by <strong>Clover</strong> — your trusted payment platform
          </div>
        </div>
      </div>

      <div style={s.main}>
        {products.map((cat) => (
          <div key={cat.category} style={s.categorySection} className="prd-fade preFade">
            <div style={s.categoryLabel}>
              <h2 style={s.categoryTitle}>{cat.category}</h2>
              <div style={s.categoryLine} />
            </div>
            <div className="products-grid" style={s.grid}>
              {cat.items.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </div>
        ))}

        {/* Wholesale Banner */}
        <div className="prd-fade preFade" style={s.wholesaleBanner}>
          <h2 style={s.bannerTitle}>Wholesale & Bulk Orders</h2>
          <p style={s.bannerText}>
            Looking for large-volume supply for your café, restaurant or retail business?
            We offer competitive wholesale pricing with direct-from-origin quality assurance.
          </p>
          <div style={s.ctaRow}>
            <a href="/#wholesale" className="btn-primary">Request Wholesale Catalog →</a>
            <Link to="/contact" className="btn-secondary">Contact Our Team</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
